import { Media, mbSize } from '@foxrenderfarm/common/src/theme'
import styled from 'styled-components'

export const CheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  margin: 0;
  cursor: pointer;
  vertical-align: middle;
  width: fit-content;
  input[type='checkbox'] {
    position: absolute;
    opacity: 0;
  }
`

export const CheckboxFrame = styled.div<{ $checked: boolean }>`
  position: relative;
  background-color: ${({ $checked }) => ($checked ? '#F3512B' : '#fff')};
  width: 20px;
  height: 20px;
  border: 2px solid ${({ $checked }) => ($checked ? '#F3512B' : '#999999')};
  border-radius: 4px;
  transition: all 0.3s;
  display: grid;
  place-content: center;
  margin-right: 10px;
  ${Media.lessThan(Media.small)} {
    margin-right: ${mbSize(15)};
    width: ${mbSize(30)};
    height: ${mbSize(30)};
    > svg {
      height: ${mbSize(12)};
    }
  }
`

export const CheckboxText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(24)};
  }
`
